import { z } from 'zod';
import { BaseSchema } from './baseSchema';

export const MymLinksSchema = BaseSchema.extend({
    uri: z.string().nullable().optional(),
});

export const NavigationRootSchema = BaseSchema.extend({
    title: z.string(),
});

export const NavigationChildrenSchema = BaseSchema.extend({
    children: z.string(),
});

export const NavigationPageSchema = BaseSchema.extend({
    term: z.string(),
    web_path: z.string(),
});

export const ReportSchema = BaseSchema.extend({
    title: z.string(),
    abstract: z.string().nullable().optional(),
    pdf_resolved: z.string().nullable().optional(),
});
